/**
 * ViewToggle — consistent grid/list view mode switcher.
 *
 * Reusable across all pages that display browsable asset/item lists.
 */

import { LayoutGrid, LayoutList } from 'lucide-react'

type ViewMode = 'grid' | 'list'

export default function ViewToggle({ mode, onChange }: { mode: ViewMode; onChange: (m: ViewMode) => void }) {
  const btn = (m: ViewMode, Icon: typeof LayoutGrid, title: string) => (
    <button
      onClick={() => onChange(m)}
      className={`p-1.5 rounded-md transition-colors ${
        mode === m
          ? 'bg-white/10 text-[var(--rq-text)]'
          : 'text-[var(--rq-text-soft)] hover:text-[var(--rq-text)]'
      }`}
      title={title}
    >
      <Icon className="w-4 h-4" />
    </button>
  )

  return (
    <div className="flex items-center gap-0.5 bg-white/[0.04] rounded-lg p-0.5">
      {btn('grid', LayoutGrid, 'Grid view')}
      {btn('list', LayoutList, 'List view')}
    </div>
  )
}
